export const CONDITIONS_LINK = 'https://www.raiffeisen.ru/static/common/SME-Documents/Widget_terms.pdf';
